import { bubbleSort, insertionSortApi,selectionSortApi, mergeSortApi } from ".";


 function SortingApi(sortingFunction, list, htmlCollectionBars, color){
    switch (sortingFunction) {
        case 'bubble-sort':
            bubbleSort([...list], htmlCollectionBars, color);
            break;
        case 'insertion-sort':
            insertionSortApi([...list], htmlCollectionBars, color);
            break
        case 'selection-sort':
               selectionSortApi([...list], htmlCollectionBars, color);
                break
        case 'merge-sort':
                    mergeSortApi([...list], htmlCollectionBars, color)
                    break
        default:
            console.log('other')
            break;
    }
}

export default SortingApi